import { Tab } from '../../types/chat';
export const saveTabsToStorage = ({STORAGE_KEY}: {STORAGE_KEY: string}, tabs: Tab[]) => {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(tabs));
};
